import { Heading, Text, VStack } from '@chakra-ui/react'
import { useLocation } from 'react-router-dom'
import { CsatPublicLayout } from '@/components/csat/CsatPublicLayout'

interface ThankYouState {
  alreadyRated?: boolean
}

export default function CsatThankYouPage() {
  const location = useLocation()
  const state = (location.state as ThankYouState | null) ?? {}
  const alreadyRated = Boolean(state.alreadyRated)

  return (
    <CsatPublicLayout>
      <VStack spacing={4} textAlign="center" py={4}>
        <Text fontSize="4xl" aria-hidden>
          {alreadyRated ? '📋' : '✓'}
        </Text>
        <Heading size="md">
          {alreadyRated ? 'Already submitted' : 'Thank you!'}
        </Heading>
        <Text color="gray.600" fontSize="md">
          {alreadyRated
            ? 'You have already submitted a rating for this ticket.'
            : 'Your feedback has been submitted successfully. We appreciate you taking the time to share your experience.'}
        </Text>
      </VStack>
    </CsatPublicLayout>
  )
}
